<template>
  <div class="py-4 container-fluid">
    <div class="card shadow-lg mt-n4">
      <div class="card-body p-3">
        <div class="row gx-4 mb-2">
          <header-title :title="'Lista utenti'"></header-title>
          <div
            class="mx-auto mt-3 col-lg-3 col-md-3 my-sm-auto ms-sm-auto me-sm-0 ps-0"
          >
            <div class="nav-wrapper position-relative end-0">
              <ul
                class="p-1 bg-transparent nav nav-pills nav-fill"
                role="tablist"
              >
                <li class="nav-item me-md-4"></li>
                <li class="nav-item">
                  <a
                    class="mb-0 btn btn-outline-warning btn-sm text-sm text-right"
                    data-bs-toggle="tab"
                    href="javascript:;"
                    role="tab"
                    aria-selected="true"
                    @click="this.addUser()"
                    ><i class="fa fa-plus"></i>
                    <span class="ms-1">Aggiungi</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <Form class="form-inline">
              <div class="form-group mb-2">
                <vee-field
                  type="text"
                  name="cerca"
                  class="search-field"
                  v-model="this.search_user_text"
                />
                <argon-button
                  size="sm"
                  class="float-end"
                  variant="gradient"
                  color="primary"
                  @click.prevent="this.searchUser"
                  >Cerca
                </argon-button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <user-table :users="this.users" v-if="this.users && !this.search_user" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import ArgonButton from "@/components/ArgonButton.vue";
import { setItem } from "@/utility/localStorageControl";
import HeaderTitle from "@/components/Header/HeaderTitle.vue";
import UserTable from "@/views/user/userTable.vue";

export default {
  name: "list-user",
  components: {
    UserTable,
    HeaderTitle,
    ArgonButton,
  },
  data() {
    return {
      users: null,
      search_user: false,
      search_user_text: "",
    };
  },
  async mounted() {
    await this.getUsers();
  },
  methods: {
    async getUsers() {
      try {
        const response = await axios.get(this.$endpoint + "/user/list", {
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });
        this.users = response.data.data;
      } catch (ex) {
        console.log(ex.message);
      }
    },
    addUser() {
      router.push({ name: "user-edit" });
    },
    async searchUser() {
      let loader;
      try {
        loader = this.$loading.show({
          loader: "dots",
          color: "#2dce89",
        });
        this.search_user = true;
        const response = await axios.get(this.$endpoint + "/user/list", {
          params: { search: this.search_user_text },
          headers: {
            authorization: process.env.VUE_APP_APY_KEY,
          },
        });
        this.users = response.data.data;
        this.search_user = false;

        await setItem("search_user", this.search_user_text);
        loader.hide();
      } catch (ex) {
        console.log(ex.message);
      }
    },
  },
};
</script>

<style>
ul li input[type="text"] {
  display: block;
}

.search-field {
  display: inline;
  width: 85%;
  padding: 0.5rem 0.75rem;
  margin-right: 0.5rem;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.8rem;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.5rem;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.text-right {
  text-align: right;
}
</style>
